import React from 'react';
import { Link } from 'react-router-dom';
import { IMenuIcon, IPrivateRoutes, PrivateRoutes } from '../../routes/private.routes';
import { NavItemMenu } from '../navItemMenu';
import { NavItem } from '../navItem';
import { useAuth } from '../../providers/auth';

const Options: React.FC<{ isOpen: boolean; handleClose?: () => void }> = ({
  isOpen,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  handleClose,
}) => {
  const { user, hasPermission, isAdmin } = useAuth();
  const podeVerCentral = isAdmin() || hasPermission('/configuracoes/permissoes');

  // Verifica se o usuário tem permissão para acessar uma rota
  const canAccessRoute = (route: IPrivateRoutes): boolean => {
    // Admin sempre tem acesso
    if (isAdmin()) return true;

    // Rotas sem código são públicas
    if (!route.codigo) return true;

    // Rotas especiais que sempre devem ser acessíveis
    const rotasPublicas = ['perfil', 'seguranca', 'sessoes'];
    if (rotasPublicas.includes(route.codigo)) return true;

    // Verifica se o usuário tem qualquer permissão para a tela (ou sub-telas)
    return hasPermission(route.path);
  };

  return (
    <div>
      {PrivateRoutes.filter(item => {
        if (user?.is_sympla) {
          return item.name === 'Sympla' && item.path === '/sympla';
        }
        return item.showSidebar && !item.isChildrenMenu && item.name !== 'Sympla';
      })
        .filter(item => {
          if (user?.grupo_id === 2 && item.path.startsWith('/configuracoes')) {
            return false;
          }
          // Restringir visualização do Config. de Bots apenas para grupo 1
          if (item.path === '/configuracao-bots' && user?.grupo_id !== 1) {
            return false;
          }
          // Verifica permissão de tela
          return canAccessRoute(item);
        })
        .map(link => {
          // Filtra os submenus também por permissão
          const childrenMenusFiltered = PrivateRoutes.filter(
            item => item.parentMenu === link.name,
          ).filter(item => {
            if (!item.showSidebar) return false;
            if (item.naCentral && podeVerCentral) return false;
            // Grupo Desenvolvedor (5) não pode ver menu de Usuários
            if (user?.grupo_id === 5 && item.path === '/configuracoes/usuarios') {
              return false;
            }
            // Verifica permissão de tela
            return canAccessRoute(item);
          });

          // Se é menu pai e não tem filhos visíveis, não mostra o menu pai
          if (link.isParentMenu && childrenMenusFiltered.length === 0) {
            return null;
          }

          return (
            <div key={link.name}>
              {link.isParentMenu ? (
                <NavItemMenu
                  parentHref={link.path}
                  icon={link.icon as IMenuIcon}
                  openMenu={isOpen}
                  parentName={link.name}
                  childrenMenus={childrenMenusFiltered}
                />
              ) : (
                <Link to={link.path}>
                  <NavItem
                    href={link.path as string}
                    icon={link.icon as IMenuIcon}
                    openMenu={isOpen}
                  >
                    {link.name}
                  </NavItem>
                </Link>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default Options;
